import {NgModule, ModuleWithProviders} from '@angular/core';

import {FishTooltip, FishTooltipWindow} from './tooltip';
import {FishTooltipConfig} from './tooltip-config';

export {FishTooltipConfig} from './tooltip-config';
export {FishTooltip} from './tooltip';


export class FishTooltipModule {
  static forRoot(): ModuleWithProviders { return {ngModule: FishTooltipModule, providers: [FishTooltipConfig]}; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{declarations: [FishTooltip, FishTooltipWindow], exports: [FishTooltip], entryComponents: [FishTooltipWindow]}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
